<template>
  <div class="order-complete-container">
    <div class="feedback">
      <Transition name="fade" @enter="enterSuccess">
        <FeedbackSuccess
          v-if="isShowableSuccess"
          message="ギフトを送信しました"
        />
      </Transition>
    </div>
    <div class="white-area order-complete-header__area">
      <PageHeadlineWithFourSteps
        title="購入完了"
        :active-step="flowLineContents.activeStep"
        :steps="flowLineContents.steps"
      />
    </div>
    <div class="white-area send-to-with-list__area">
      <div class="content-inner-area">
        <div class="send-to-with-list__message--area">
          <p class="headline send-to-with-list__message--main">Thank you!</p>
          <p class="minimal">ギフトの送信が完了しました</p>
        </div>
        <div class="send-image-area">
          <div class="gift-in-circle-image">
            <GiftInCircle />
          </div>
          <template v-if="showableWishListUser">
            <SendGiftArrow class="send-gift-arrow-image" />
            <AccountIconWh80
              class="profile-edit-form__account-icon"
              :image-url="wishListUserIconImagePath"
            />
          </template>
        </div>
        <SendGiftButtons
          v-if="!isApp"
          :gift-url="giftUrl"
          is-copy-button-primary
          is-displayable-toggle-text-link
        />
        <ToAppArea v-else @click-app-button="onClickAppButton">
          決済は正常に完了しています。お手数ですが下記のボタンから、ご利用いただいていたgifteeアプリにお戻りいただきますようお願いいたします。
        </ToAppArea>
        <div class="order-code__area">
          <span class="body order-code__label">注文番号</span>
          <span class="body order-code__value">
            {{ orderCode }}
          </span>
        </div>
      </div>
    </div>
    <div v-if="!isApp" class="white-area">
      <div class="content-inner-area">
        <div class="send-another__area">
          <p class="send-another__title">続けてギフトを贈る</p>
          <div
            v-if="showableWishListUser"
            class="buttons-multi send-another__multi-button--area"
          >
            <ButtonMulti
              position="top"
              class="back-wish-list"
              chevron-forward
              @click-button="onClickBackWishList(profilePath)"
            >
              <span class="back-wish-list__nickname">
                {{ wishListUserNickName }}
              </span>
              <span class="back-wish-list__sentence">
                さんのほしいものリストに戻る
              </span>
            </ButtonMulti>
            <ButtonMulti
              position="bottom"
              class="back_to_top__multi-button--button"
              chevron-forward
              @click-button="onClickBackToTop"
            >
              トップページに戻る
            </ButtonMulti>
          </div>
          <div v-else class="buttons-multi send-another__multi-button--area">
            <ButtonMulti
              single
              class="back_to_top__multi-button--button"
              chevron-forward
              @click-button="onClickBackToTop"
            >
              トップページに戻る
            </ButtonMulti>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FeedbackSuccess from '../../atoms/feedbacks/feedback-success.vue'
import PageHeadlineWithFourSteps from '../../molecules/headlines/PageHeadlineWithFourSteps.vue'
import AccountIconWh80 from '../../atoms/account_icons/AccountIconWh80.vue'
import SendGiftButtons from './send-gift-buttons.vue'
import ButtonMulti from '../../atoms/buttons-multi/ButtonMulti.vue'
import GiftInCircle from '../../atoms/svg_icons/GiftInCircle.vue'
import SendGiftArrow from '../../atoms/svg_icons/SendGiftArrow.vue'
import ToAppArea from './ToAppArea.vue'

export default {
  components: {
    ToAppArea,
    SendGiftArrow,
    GiftInCircle,
    ButtonMulti,
    SendGiftButtons,
    AccountIconWh80,
    PageHeadlineWithFourSteps,
    FeedbackSuccess
  },
  props: {
    showableWishListUser: {
      type: Boolean,
      required: false,
      default: false
    },
    wishListUserNickName: {
      type: String,
      required: false,
      default: ''
    },
    profilePath: {
      type: String,
      required: false,
      default: ''
    },
    wishListUserIconImagePath: {
      type: String,
      required: false,
      default: ''
    },
    giftUrl: {
      type: String,
      required: true
    },
    orderCode: {
      type: String,
      required: true
    },
    isApp: {
      type: Boolean,
      required: false,
      default: false
    },
    orderHistoriesDeepLink: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      isShowableSuccess: false,
      giftInCircleImage: '',
      sendGiftArrowImage: '',
      flowLineContents: {
        steps: ['作成', 'プレビュー', '確認', '完了'],
        activeStep: 4
      }
    }
  },
  mounted() {
    this.isShowableSuccess = true
  },
  methods: {
    enterSuccess() {
      setTimeout(() => {
        this.isShowableSuccess = false
      }, 3000)
    },
    onClickBackToTop() {
      dataLayer.push({
        event: 'click_orders_complete__top'
      })
      window.location.href = '/'
    },
    onClickBackWishList(path) {
      dataLayer.push({
        event: 'click_orders_complete__wishlist'
      })
      window.location.href = path
    },
    onClickAppButton() {
      window.location.href = this.orderHistoriesDeepLink
    }
  }
}
</script>

<style lang="scss" scoped>
.order-complete-container {
  .send-image-area {
    display: flex;
    justify-content: center;
    gap: 16px;
    margin-bottom: 40px;
    @media screen and (max-width: $small-contents-width) {
      margin-bottom: 10.67vw;
    }

    .gift-in-circle-image {
      @media screen and (max-width: $small-contents-width) {
        // 16px(基準のpadding or margin)/375px(基準の親要素のwidth)*100 = 4.266...
        margin-right: 4.27vw;
      }

      svg {
        width: 80px;
        height: 80px;

        path {
          fill: $primary;
        }
      }
    }

    .send-gift-arrow-image {
      margin: auto 0 auto;
      @media screen and (max-width: $small-contents-width) {
        // 16px(基準のpadding or margin)/375px(基準の親要素のwidth)*100 = 4.266...
        margin-right: 4.27vw;
      }

      svg {
        display: block;

        path {
          fill: $primary;
        }
      }
    }
  }

  .send-button {
    &__area {
      margin-bottom: 40px;
      padding: 0 16px 0;
      @media screen and (max-width: $small-contents-width) {
        // 40px(基準のpadding or margin)/375px(基準の親要素のwidth)*100 = 10.666...
        margin-bottom: 10.67vw;
        // 16px(基準のpadding or margin)/375px(基準の親要素のwidth)*100 = 4.266...
        padding-left: 4.27vw;
        padding-right: 4.27vw;
      }
    }

    &__message {
      margin-bottom: 16px;
      @media screen and (max-width: $small-contents-width) {
        margin-bottom: 4.27vw;
      }
    }

    span {
      display: inline-block;
      vertical-align: middle;
    }

    .wish-list-user-name {
      text-overflow: ellipsis;
      overflow: hidden;
      // ボタンのwidth 343px - ボタン内のpadding 16px * 左右分で 2 - 1文字分のwidth 1.6rem * ニックネームの後ろの「さんに贈る」分で 5
      max-width: calc(343px - 16px * 2 - 1.6rem * 5);
      @media screen and (max-width: $small-contents-width) {
        // ボタンのwidth が (画面の幅 100vw - ボタンのmargin 16px / 375px * 100 = 4.266... * 左右分で 2) になる
        max-width: calc(100vw - 4.27vw * 2 - 16px * 2 - 1.6rem * 5);
      }
    }
  }
}
</style>
